import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { Button } from "./ui/button";

const links = [
  { label: "Services", href: "#services" },
  { label: "Process", href: "#process" },
  { label: "Work", href: "#work" },
  { label: "Testimonials", href: "#testimonials" },
];

export const Navbar = ({ onConsult }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "backdrop-blur-xl bg-[#05030A]/75 border-b border-white/5"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="logo-link"
          data-cursor="hover"
          className="flex items-center gap-3"
        >
          <img
            src="https://customer-assets.emergentagent.com/job_efficiency-systems/artifacts/guzhatny_FLOWBASE.png"
            alt="FlowBase"
            className="fb-logo-img"
          />
          <span className="neon-logo text-2xl">FlowBase</span>
        </a>

        <nav className="hidden md:flex items-center gap-8" aria-label="primary">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="text-sm text-white/70 hover:text-white transition-colors relative after:content-[''] after:absolute after:left-0 after:-bottom-1 after:h-px after:w-0 after:bg-[#B026FF] hover:after:w-full after:transition-all"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <Button
            data-testid="navbar-consult-btn"
            onClick={onConsult}
            className="btn-neon rounded-full px-5 h-10 font-medium border-0"
          >
            Get a Free Consultation
          </Button>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden text-white p-2"
          onClick={() => setOpen((v) => !v)}
          aria-label="toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-white/10 bg-[#05030A]/95 backdrop-blur-lg">
          <div className="px-6 py-4 flex flex-col gap-4">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-white/80 hover:text-white"
                data-testid={`mobile-nav-${l.label.toLowerCase()}`}
              >
                {l.label}
              </a>
            ))}
            <Button
              data-testid="mobile-consult-btn"
              onClick={() => {
                setOpen(false);
                onConsult();
              }}
              className="btn-neon rounded-full h-11"
            >
              Get a Free Consultation
            </Button>
          </div>
        </div>
      )}
    </header>
  );
};
